import { createContext } from 'react'

// True inside a page/card header region (set by CardHeader). Together with
// TableMenuContext it tells <Menu> the two places where common actions pin by
// default — page headers (as buttons) and table rows (as inline icons). Anywhere
// else (content cards, inline lists) collapses into the kebab.
export const MenuHeaderContext = createContext(false)
